export default __webpack_public_path__ + "static/media/eden.9da594d1.svg";